module.exports = __webpack_public_path__ + "img/4.7a4c84b3.jpg";